import {
  MenuCockpit,
  MenuCockpitFilled,
  MenuDevicePlus,
} from "@/assets/icons/icons";
import type { PortalNavigationItem } from "@/components/Layout/PortalShellConfig";

export const partnerNavigationItems: PortalNavigationItem[] = [
  {
    icon: <MenuCockpit />,
    activeIcon: <MenuCockpitFilled />,
    text: "layout.menu.items.cockpit",
    target: "/partner/cockpit",
  },
  {
    icon: <MenuDevicePlus />,
    activeIcon: <MenuDevicePlus />,
    text: "portal:add-device.heading",
    target: "/partner/add-sim",
  },
] as const;
